import React, { useEffect } from "react";
import "../index.css";
import { buildVersion } from "../services/buildInfo";

function ThankYouTwo() {

  // Adobe DataLayer (KEPT)
  useEffect(() => {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
      "event": "pageView",
      "web": {
        "webPageDetails": {
          "pageViews": {
            "value": 1
          },
          "name": "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:not eligible thankyou page",
          "URL": window.location.href,
          "isErrorPage": "False",
        }
      },
      "_icicibank": {
        "channelInfo": {
          "version": buildVersion,
          "name": "nli",
        },
        "pageInfo": {
          "language": "en",
          "country": "in",
          "pageType": "campaign",
          "virtualPageView": "no vpv",
          "journey": "na",
          "subJourney": "na",
          "subSubJourney": "na",
        },
        "userInfo": {
          "userType": "na"
        },
        "errorInfo": {
          "errorType": "na",
          "errorDetails": "na"
        }
      }
    });
  }, []);

  return (
    <>
      <article className="thankyou_sec">
        <div className="container ">
          <div className="thankyou_txt noteligible">
            <p>
              We are unable to process your request.
              <br />
              Regret the inconvenience caused.
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default ThankYouTwo;
